export default "__VITE_ASSET__32664512__"